/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedRelatedPages_buyPage = {
    readonly relatedBuyPages: ReadonlyArray<{
        readonly anchorText: string | null;
        readonly url: string | null;
    } | null> | null;
    readonly " $refType": "BuySharedRelatedPages_buyPage";
};
export type BuySharedRelatedPages_buyPage$data = BuySharedRelatedPages_buyPage;
export type BuySharedRelatedPages_buyPage$key = {
    readonly " $data"?: BuySharedRelatedPages_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedRelatedPages_buyPage">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedRelatedPages_buyPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InternalBuyLinkType",
      "kind": "LinkedField",
      "name": "relatedBuyPages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "anchorText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '565fb4bd3ed9fd07f7fb567067f6f1bf';
export default node;
